import axiosConn from '../../axiosConn';

export const RADIO_LISTEN_EVENT_ENDPOINT = 'hitlab/radio/listen-events';
export const RADIO_LISTEN_HEARTBEAT_MS = 15000;

const cleanText = (value, max = 160) =>
  String(value || '')
    .replace(/[\r\n\t]+/g, ' ')
    .trim()
    .slice(0, max);

const toSafeSeconds = (value) => {
  const number = Number(value);
  if (!Number.isFinite(number) || number < 0) return 0;
  return Math.floor(number);
};

export const buildRadioListenSessionId = (surface, trackId) => [
  cleanText(surface || 'radio', 40).replace(/[^a-z0-9_-]/gi, ''),
  cleanText(trackId || 'track', 80).replace(/[^a-z0-9_-]/gi, ''),
  Date.now(),
  Math.random().toString(36).slice(2, 10),
].join(':');

export const getAudioListenSnapshot = (audio, durationFallback = 0) => {
  const duration = Number(audio?.duration);
  const position = Number(audio?.currentTime);
  return {
    durationSeconds: toSafeSeconds(
      Number.isFinite(duration) ? duration : durationFallback,
    ),
    positionSeconds: toSafeSeconds(position),
  };
};

export const sendRadioListenEvent = ({
  eventType,
  sessionId,
  trackId,
  source,
  playerToken,
  durationSeconds,
  positionSeconds,
  invitationReference,
} = {}) => {
  const cleanEventType = cleanText(eventType, 40);
  const cleanSessionId = cleanText(sessionId, 160);
  const cleanTrackId = cleanText(trackId, 120);
  if (!cleanEventType || !cleanSessionId || !cleanTrackId) return;

  const config = playerToken
    ? {
        headers: {
          Authorization: `Bearer ${playerToken}`,
        },
      }
    : undefined;

  try {
    const request = axiosConn.post(
      RADIO_LISTEN_EVENT_ENDPOINT,
      {
        eventType: cleanEventType,
        sessionId: cleanSessionId,
        trackId: cleanTrackId,
        source: cleanText(source, 80) || 'joe_galaxy_radio',
        durationSeconds: toSafeSeconds(durationSeconds),
        positionSeconds: toSafeSeconds(positionSeconds),
        ...(cleanEventType === 'start' && invitationReference ? { invitationReference } : {}),
      },
      config,
    );
    if (request && typeof request.catch === 'function') {
      request.catch(() => {});
    }
  } catch (err) {
    // Listener metrics must never interrupt Radio playback.
  }
};
